import { Injectable, inject } from '@angular/core';
import { MeasurementResponse } from '@core/interfaces/measurement-response';
import { MeasurementDeviceBaseService } from '@core/services/base/measurement-device-base.service';
import { Observable } from 'rxjs';
import { LoggerService } from '@shared/services/logger.service';
import { BluetoothService } from './bluetooth.service';

@Injectable({
  providedIn: 'root',
})
export class MeasurementDeviceService extends MeasurementDeviceBaseService {
  #logger = inject(LoggerService);
  #bluetoothService = inject(BluetoothService);

  public dataCaptureStop(): void {
    this.thicknessDataReceived();
  }

  public sendThicknessRequest(): Promise<number> {
    return this.#bluetoothService.writeOperation('THKAGC?');
  }

  public sendUnitOfMeasurementRequest(): Promise<number> {
    return this.#bluetoothService.writeOperation('UNITS?');
  }

  public onDataFrom38DLReceived(): Observable<MeasurementResponse> {
    let valueString: string;
    return new Observable(observer => {
      this.#bluetoothService.onDataNotified().subscribe({
        next: data => {
          const decoder = new TextDecoder('utf-8');
          valueString = '' + decoder.decode(data);
          this.#logger.info('Data After Decode: ', valueString);
          const thickness = Number.parseFloat(valueString.replace(/-*.--\s/g, '')) || null;
          observer.next({ data: thickness });
        },
        error: err => {
          observer.next(null);
        },
      });
    });
  }
}
